import React from 'react';
import PropTypes from 'prop-types';
import { clsx } from 'clsx';
import { useWindowWidth } from '../../Atoms/ResponsiveComponentSwitch';
import { ESSButton } from '../../Atoms/ESSButton';
import Dropdown from '../../Molecules/DropDown/Dropdown';
import "./FilterMenu.scss";

/**
 * FilterMenu - Responsive filter menu component.
 *
 * Desktop (>=768px): Horizontal row of buttons (flex-wrap).
 *   Active item = positive variant, inactive = negative variant.
 *
 * Mobile (<768px): Dropdown with an optional title above it.
 */
const FilterMenu = ({
  items = [],
  activeId,
  onChange,
  mobileLabel = 'Filter by',
  className,
  breakpoint = 0,
  centered = false,
}) => {
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth > 0 && windowWidth < breakpoint;

  const handleFilterChange = (id) => {
    if (onChange) {
      onChange(id);
    }
  };

  const handleButtonClick = (id) => {
    if (onChange) {
      onChange(id);
    }
  };

  if (isMobile) {
    return (
      <div className={clsx('filter-menu', 'filter-menu--mobile', className)}>
        {mobileLabel && (
          <span className="filter-menu__mobile-label">{mobileLabel}</span>
        )}
        <Dropdown
          className="filter-menu__dropdown"
          label={
            items.find((f) => f.id === activeId)
              ?.label || activeId
          }
          triggerSize="sm"
          menuItemSize="sm"
          items={items.map((item) => ({
            id: item.id,
            label: item.label,
            onSelect: () => handleFilterChange(item.id),
          }))}
        />
      </div>
    );
  }

  return (
    <div
      className={clsx(
        'filter-menu',
        'filter-menu--desktop',
        centered && 'filter-menu--centered',
        className,
      )}
    >
      {items.map((item) => (
        <ESSButton
          key={item.id}
          variant={item.id === activeId ? 'positive' : 'negative'}
          text={item.label}
          onClick={() => handleButtonClick(item.id)}
          className="filter-menu__button"
        />
      ))}
    </div>
  );
};

FilterMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  activeId: PropTypes.string,
  onChange: PropTypes.func,
  mobileLabel: PropTypes.string,
  className: PropTypes.string,
  breakpoint: PropTypes.number,
  centered: PropTypes.bool,
};

export default FilterMenu;
